import { render, staticRenderFns } from "./eDSCompMyTaskList.vue?vue&type=template&id=452b83e8"
import script from "./eDSCompMyTaskList.vue?vue&type=script&lang=js"
export * from "./eDSCompMyTaskList.vue?vue&type=script&lang=js"
import style0 from "./eDSCompMyTaskList.vue?vue&type=style&index=0&id=452b83e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports